var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgSquareDefault = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "21px",
  height: "21px",
  viewBox: "0 0 21 21",
  xmlns: "http://www.w3.org/2000/svg",
  className: "react-svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M19.0052288,1 C19.5546258,1 20,1.45092539 20,1.99477117 L20,19.0052288 C20,19.5546258 19.5490746,20 19.0052288,20 L1.99477117,20 C1.44537422,20 1,19.5490746 1,19.0052288 L1,1.99477117 C1,1.44537422 1.45092539,1 1.99477117,1 L19.0052288,1 Z M16.0014977,4 L4.99850233,4 C4.44748943,4 4,4.44704472 4,4.99850233 L4,4.99850233 L4,16.0014977 C4,16.5525106 4.44704472,17 4.99850233,17 L4.99850233,17 L16.0014977,17 C16.5525106,17 17,16.5529553 17,16.0014977 L17,16.0014977 L17,4.99850233 C17,4.44748943 16.5529553,4 16.0014977,4 L16.0014977,4 Z M15,6 L15,15 L6,15 L6,6 L15,6 Z",
  fill: "currentColor"
}))));
export default SvgSquareDefault;